<template>
  <div class="wrap-content wrap-contribute-compare f-tal pd15">
    <v-breadcrumb v-if="isShowBread" :breadcrumb-list="breadcrumbList" />
    <div class="list-filter-wrap-box breadcrumb-btm-con-box">
      <v-list-filter
        v-model="bindForms"
        :form-arr="formArr"
        :form-rules="formRules"
        :is-add-btn="false"
        form-item-position="row"
        class="list-filter bg-white"
        @changeFormBind="changeFormBind" />
    </div>
    <div class="wrap-main-content">
      <!--指标总览-->
      <div class="pd15 bg-white mg-top15">
        <v-title :tip-txt="titleTxt[0].tipTxt" title="指标总览">
          <div class="f-df f-ai pd-right15">
            <label>排序指标：</label>
            <!--排序指标-->
            <el-select
              v-model="pageObj.sortIndex"
              placeholder="请选择"
              style="width: 140px;"
              @change="getList()">
              <el-option
                v-for="(elem, i) in sortIndex"
                :key="i"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
            <!--排序顺序-->
            <el-select
              v-model="pageObj.sortRule"
              placeholder="请选择"
              style="width: 100px;"
              class="mg-left10"
              @change="getList()">
              <el-option
                v-for="(elem, i) in sortRules"
                :key="i"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
          </div>
        </v-title>
        <v-table-list
          :is-loading="isLoading[0]"
          :table-head="tableHead"
          :table-btn="tableBtn"
          :page-list="pageList"
          :current-page="pageObj.page"
          :page-size="pageObj.pageSize"
          :total-size="pageObj.totalSize"
          :is-show-selection="false"
          :is-table-operation-btn="true"
          class="bg-white pd-row15 compet-table"
          @rowOperatBtn="rowOperatBtn"
          @sizeChange="sizeChange"
          @currentChange="currentChange" />
      </div>
      <div class="pd15 bg-white mg-top15 volumnTrend">
        <v-title :tip-txt="titleTxt[1].tipTxt" title="指标趋势" />
        <div class="f-pr">
          <div class="f-pa volumn-filter-box">
            <v-list-filter
              v-model="volumnBindValue"
              :form-arr="volumnFormArr"
              :is-add-btn="false"
              form-item-position="row"
              class="volumn-list-filter bg-white"
              @changeFormBind="volumnChange" />
          </div>
          <no-data v-if="isNodata[1] && !isLoading[1]" height="430" />
          <div
            v-show="!isNodata[1]"
            id="volumn-tren-line-chart"
            v-loading="isLoading[1]"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            class="chart-box mg-top20 volumn-tren-line-chart"
          ></div>
        </div>
      </div>
      <div
        v-for="(modelItem, modelIndex) in columnList"
        :key="modelIndex"
        class="pd15 bg-white mg-top15 contribute-compare-box">
        <v-title :title="modelItem.name" :tip-txt="modelItem.tipTxt">
          <div class="f-df f-ai pd-right15">
            <label>对比指标：</label>
            <!--排序指标-->
            <el-select
              v-model="contributeObj[modelItem.selectKey]"
              placeholder="请选择"
              style="width: 140px;"
              @change="getColumnData(modelItem)">
              <el-option
                v-for="(elem, i) in contributeObj.sorts"
                :key="i"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
          </div>
        </v-title>
        <div class="d-df">
          <!--柱状图列表集合-->
          <section class="chart-list">
            <ul class="f-df f-fww">
              <li
                v-for="item in modelItem.charts"
                :key="item.id"
                class="item-bar-chart-box bg-white pd-row15 bg-white f-pr">
                <h3 class="f-fwn second-title">{{ item.name }}</h3>
                <no-data v-if="item.isNodata && !item.isLoading" height="430" />
                <div
                  v-show="!item.isNodata"
                  :id="item.id"
                  v-loading="item.isLoading"
                  :class="item.id"
                  element-loading-text="加载中"
                  element-loading-spinne-r="el-icon-loading"
                  class="chart-box mg-top20"
                ></div>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page.config.js'
import noData from '@/components/nodata.vue'
import vBreadcrumb from '@/components/breadcrumb.vue'
import vListFilter from '@/components/form-filter/index.vue'
import vTitle from '@/components/vTitle.vue'
import vTableList from '@/components/table-list.vue'
import $filterCommon from '@/components/form-filter/index.js'
import mixin from '@/views/analysis/analysis.js'
// import chartRender from '@/views/analysis/chartRender.js'
import {
  getVoiceTrend,
  getSortLabel,
  getList,
  // getListTotal,
  getCompetitiveSortLabel,
  getColumnData
} from '@/api/analysis/competCompare.js'
export default {
  components: {
    noData,
    vBreadcrumb,
    vListFilter,
    vTitle,
    vTableList
  },
  mixins: [mixin],
  data() {
    return {
      isShowBread: true,
      breadcrumbList: [
        {
          name: '数据分析'
        },
        {
          name: '竞品对比'
        }
      ],
      isLoading: [false, false, false],
      isNodata: [false, false, false],
      titleTxt: pageConfig.titleTxt,
      bindForms: {},
      formArr: [],
      formRules: {},
      volumnFormArr: [], // 声量趋势
      volumnBindValue: {}, // 声量趋势
      tableHead: [], // 表头
      tableBtn: [], // 表格操作按钮组
      pageList: [], // 产线分析数据
      sortIndex: [],
      sortRules: pageConfig.sortRules,
      pageObj: {
        page: 1,
        pageSize: 10,
        totalSize: 0,
        sortIndex: '', // issue_date按发布时间排序，impl_date按实施时间排序
        sortRule: '1' // 1倒序，2升序
      },
      brandList: [], // 品牌
      analysisLableData: [], // 分析的label数据
      contributeObj: {
        sorts: pageConfig.contributeSorts,
        contributeSortIndex: 'total_cost',
        contentSortIndex: 'total_cost'
      },
      columnList: pageConfig.columnList
    }
  },
  mounted() {
    // 产线分析
    this.tableHead = JSON.parse(JSON.stringify(pageConfig.tableHead))
    this.tableBtn = JSON.parse(JSON.stringify(pageConfig.tableBtn))
    // 分析初始化
    // this.getContributeInit()
    Promise.all([
      this.getSortLabel(), // 获取排序指标
      this.getCompetitiveSortLabel(), // 排序条形图对比指标
      this.getContributeInit() // 分析初始化
    ]).then(data => {
      // 开始初始化
      this.init()
    })
  },
  methods: {
    init() {
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        this.brandList = data[0].data
        // 表单
        const formArr = JSON.parse(JSON.stringify(pageConfig.filterForm))
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        this.bindForms = filterObj.filterChooseObj
        this.formArr = filterObj.filterList
        // 声量趋势
        this.volumnInit()
        // 页面统一请求初始化并且请求
        const timeChooseItem = this.formArr.find(item => item.id === 'dateMonth') || {}
        this.changeFormBind(this.bindForms, timeChooseItem, this.bindForms[timeChooseItem.intValue])
      })
    },
    // 初始化
    volumnInit() {
      const formArr = JSON.parse(JSON.stringify(pageConfig.volumnFormArr))
      // 初始化所有筛选条件集合
      const filterObj = $filterCommon.filterChooseHandle(formArr, [])
      // 初始化当前选择的筛选条件
      this.volumnBindValue = filterObj.filterChooseObj
      this.volumnFormArr = filterObj.filterList
    },
    // 页面各个模块总入口请求
    pageTotalAjax() {
      // 趋势数据
      this.getVoiceTrend()
      // 获取产线分析数据
      this.refreshList()
      // 达人贡献对比分析
      this.getColumnData()
    },
    // 获取排序指标
    getSortLabel() {
      return new Promise((resolve, reject) => {
        getSortLabel().then(res => {
          this.sortIndex = $filterCommon.getDataHandle(res.data || [], 'labelName', 'name')
          this.pageObj.sortIndex = this.sortIndex.length ? this.sortIndex[0].id : ''
          resolve({
            id: 'tableSort',
            data: this.sortIndex
          })
        })
      })
    },
    // 排序条形图对比指标
    getCompetitiveSortLabel() {
      return new Promise((resolve, reject) => {
        getCompetitiveSortLabel().then(res => {
          const data = $filterCommon.getDataHandle(res.data || [], 'labelName', 'name')
          this.contributeObj.sorts = data
          this.contributeObj.contributeSortIndex = data.length ? data[0].id : ''
          this.contributeObj.contentSortIndex = data.length ? data[0].id : ''
          resolve({
            id: 'competitivetableSort',
            data: data
          })
        })
      })
    },
    // 获取产线分析数据
    getList(currentPage, pageSize) {
      this.$set(this.isLoading, 0, true)
      this.pageObj.page = currentPage || 1
      pageSize && (this.pageObj.pageSize = pageSize)
      this.pageList = []
      !currentPage && (this.pageObj.totalSize = -1)
      getList(Object.assign(this.getParam(), {
        startPageNum: this.pageObj.page,
        pageSize: this.pageObj.pageSize,
        sortItem: this.pageObj.sortIndex,
        isSortMax: this.pageObj.sortRule
      })).then(res => {
        this.$set(this.isLoading, 0, false)
        const data = res.data || {}
        this.pageList = (data.items || []).map((item, index) => {
          item.$index = index + 1
          const brandLogoPath = process.env.VUE_APP_IMG_PATH + item.logoPath
          let str = '<div class="compet-logo-box f-df f-ai"><figure class="compet-figure-logo-box"><img src=' + brandLogoPath + ' width="100%" height="100%" /></figure>'
          str += '<figcaption>' + item.brand + '</figcaption></div>'
          item.brandHtml = str
          return item
        })
        !currentPage && (this.pageObj.totalSize = data.total || 0)
      })
    },
    // 获取产线分析数据总数
    getListTotal() {
      // this.pageObj.totalSize = -1
      // getListTotal(this.getParam()).then(res => {
      //   this.pageObj.totalSize = res.data || 0
      // })
    },
    // 表格按钮
    rowOperatBtn(rowData, item) {
      this.$store.dispatch('setPlatParam', {
        brand: rowData[0].brand,
        lineName: (!rowData[0].lineName || rowData[0].lineName === '不限') ? '' : rowData[0].lineName,
        timeType: this.bindForms.timeType,
        dateMonth: this.bindForms.dateMonth,
        dateTimeStartTime: this.bindForms.dateTimeStartTime,
        dateTimeEndTime: this.bindForms.dateTimeEndTime,
        isPrereport: this.bindForms.isPrereport
      })
      this.$router.push({
        path: '/dataBroad',
        query: {
          brand: rowData[0].brand,
          lineName: rowData[0].lineName
        }
      })
    },
    // 趋势选择
    volumnChange(bindForms, item, value) {
      this.volumnBindValue = bindForms
      this.getVoiceTrend()
    },
    // 绘制趋势
    getVoiceTrend(seriesData) {
      this.$set(this.isLoading, 1, true)
      this.$set(this.isNodata, 1, false)
      // 特殊处理时间参数
      const param = this.paramTimeHandle(this.getParam())
      // 开始请求接口
      getVoiceTrend(Object.assign(param, {
        selectType: this.volumnBindValue.selectType
      })).then(res => {
        this.$set(this.isLoading, 1, false)
        const data = res.data || []
        // 过滤掉品牌全部为0的数据
        const filterBrandList = !param.brandList.length ? this.brandList : this.brandList.filter(item => param.brandList.indexOf(item.name) >= 0)
        const brandList = filterBrandList.reduce((preArr, item, index) => {
          const key = item.pinyin
          const isZeroItem = data.find(dataItem => dataItem[key] * 1 !== 0)
          if (isZeroItem) preArr.push(item)
          return preArr
        }, [])
        // 所有数据都为0
        if (!brandList.length) {
          this.$set(this.isNodata, 1, true)
          return
        }
        // x轴的值
        const xData = []
        // y轴对应series值
        const color = ['#326CFA', '#E77A39', '#7198f7', '#409EFF', '#33c6f7', '#b0e9fc', '#d9f4fe', '#ED9E6E', '#FFBC22']
        const seriesData = brandList.map((item, index) => {
          return {
            name: item.name,
            type: 'line',
            key: item.pinyin,
            data: [],
            itemColor: color[index % color.length]
          }
        })
        const selectType = this.volumnFormArr[0].children.find(item => item.id === this.volumnBindValue.selectType) || {}
        // 开始出图
        // const colorArr = ['#FFB600', '#ED9E6E', '#FFBC22']
        const dataList = data.map(item => {
          const obj = (item.indexs || []).reduce((preObj, elem) => {
            preObj[elem.name] = elem.indexCnt
            return preObj
          }, {})
          delete item.indexs
          return Object.assign(item, obj)
        })
        const xKey = 'dataTime'
        dataList.forEach(item => {
          const xValue = item[xKey]
          xData.push({
            value: param.timeType * 1 === 0 ? xValue.substr(0, 7) : xValue,
            textStyle: {
              fontSize: 14,
              lineHeight: 24
            }
          })
          seriesData.forEach((seriesItem, index) => {
            seriesItem.data.push({
              value: item[seriesItem.key] ? item[seriesItem.key] * 1 : 0,
              xdata: item[xKey]
            })
          })
        })
        this.$nextTick(() => {
          // 定义值只显示几条柱子
          const dataZoomLg = 31
          const xAxis = this.$chart.getXAxis(xData)
          const yAxis = [
            {
              name: selectType.name,
              axisLabel: {
                formatter: '{value}'
              }
            }
          ]
          const option = this.$chart.mixBarLineChart(xData, yAxis, seriesData, true, {
            show: dataList.length > dataZoomLg,
            dataZoomLg: dataZoomLg,
            bottom: 100,
            zoomLock: false,
            xAxisIndex: xAxis.length > 1 ? [0, 1] : [0]
          }, {
            top: 50,
            bottom: dataList.length > dataZoomLg ? 80 : 60
          }, {
            bottom: 0
          }, xAxis, 1)
          // 图形销毁重新绘制
          document.getElementById('volumn-tren-line-chart').removeAttribute('_echarts_instance_')
          // 重新绘制,重新加载数据
          const myChart = this.$echarts.init(document.getElementById('volumn-tren-line-chart'))
          myChart.setOption(option, true)
          // 根据屏幕的大小来缩放
          window.onresize = () => {
            myChart.resize()
          }
        })
      })
    },
    // 获取贡献对比分析
    getContributeInit() {
      // 请求所有条件
      const barLabelAjaxList = JSON.parse(JSON.stringify(pageConfig.barLabelAjaxList))
      Promise.all(barLabelAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        this.analysisLableData = data
      })
    },
    // 图表初始化
    getColumnData(modelItem = {}) {
      const columnList = !modelItem.id ? this.columnList : this.columnList.filter(item => item.id === modelItem.id)
      const analysisLableData = !modelItem.id ? this.analysisLableData : this.analysisLableData.filter(item => modelItem.flagKeys.indexOf(item.id) >= 0)
      // 处理x轴数据
      const color = ['#326CFA', '#7198f7', '#33c6f7', '#b0e9fc', '#d9f4fe', '#E77A39', '#ED9E6E', '#FFBC22']
      const emphasisColor = ['#1c5cf9', '#5585f8', '#38d9ff', '#c1ffff', '#eeffff', '#f77c33', '#f3a97d', '#fbc343']
      // 开始请求数据
      const promiseAll = columnList.reduce((preArr, columnItem, columnIndex) => {
        columnItem.charts.forEach(item => {
          item.isLoading = true
          item.isNodata = false
          preArr.push(getColumnData(Object.assign(this.getParam(), {
            type: item.type,
            index: columnIndex === 0 ? this.contributeObj.contributeSortIndex : this.contributeObj.contentSortIndex
          })))
        })
        return preArr
      }, [])
      Promise.all(promiseAll).then(data => {
        const columnData = analysisLableData.map((labelObj, labelIndex) => {
          const seriesData = labelObj.data.map((item, index) => {
            const obj = {
              name: item.name,
              type: 'bar',
              stack: 'total',
              barWidth: 12,
              data: [],
              itemColor: color[index % color.length],
              emphasisColor: emphasisColor[index % emphasisColor.length],
              key: item.id,
              unit: '%'
            }
            return obj
          })
          // 只展示品牌有值的数据
          // x轴的值
          const xData = data[labelIndex].data.map(item => {
            return {
              value: item.brand || '',
              textStyle: {
                fontSize: 14,
                lineHeight: 24
              }
            }
          })
          const dataList = xData.map(item => {
            const obj = seriesData.reduce((preObj, elem) => {
              const res = data[labelIndex].data || []
              // 找到对应的品牌
              const brandItem = res.find(resItem => resItem.brand === item.value) || { dataList: [] }
              // 找到对应品牌的值
              const ydata = brandItem.dataList.find(item => item.name === elem.name) || {}
              preObj[elem.key] = (ydata.rate || 0) * 100
              // preObj[elem.key] = Math.floor(Math.random() * 100)
              return preObj
            }, {})
            return obj
          })
          // 展示所有品牌
          // x轴的值
          // const xData = this.brandList.map(item => {
          //   return {
          //     value: item.name || '',
          //     textStyle: {
          //       fontSize: 14,
          //       lineHeight: 24
          //     }
          //   }
          // })
          // const dataList = xData.map(item => {
          //   const obj = seriesData.reduce((preObj, elem) => {
          //     const res = data[labelIndex].data || []
          //     // 找到对应的品牌
          //     const brandItem = res.find(resItem => resItem.brand === item.value) || { dataList: [] }
          //     // 找到对应品牌的值
          //     const ydata = brandItem.dataList.find(item => item.name === elem.name) || {}
          //     preObj[elem.key] = (ydata.rate || 0) * 100
          //     // preObj[elem.key] = Math.floor(Math.random() * 100)
          //     return preObj
          //   }, {})
          //   return obj
          // })
          // 模拟数据
          // const dataList = xData.map(item => {
          //   const obj = seriesData.reduce((preObj, elem) => {
          //     preObj[elem.key] = Math.floor(Math.random() * 100)
          //     return preObj
          //   }, {})
          //   return obj
          // })
          // console.log(dataList)
          return {
            xData,
            seriesData,
            dataList
          }
        })
        // 开始渲染数据
        setTimeout(() => {
          columnList.forEach((columnItem, i) => {
            columnItem.charts.forEach((item, index) => {
              item.isLoading = false
              const seriesData = columnData[i * 2 + index].seriesData
              const dataList = columnData[i * 2 + index].dataList
              const xData = columnData[i * 2 + index].xData
              // 所有数据都为0
              if (!dataList.length) {
                item.isNodata = true
                return
              }
              this.columnRender(item.id, xData, JSON.parse(JSON.stringify(seriesData)), dataList)
            })
          })
        }, 200)
      })
    },
    // 柱状图绘制
    columnRender(id, xData, seriesData, dataList, yAxisName, yAxisPdLeft) {
      dataList.forEach(item => {
        seriesData.forEach(seriesItem => {
          seriesItem.data.push({
            value: item[seriesItem.key] ? item[seriesItem.key] * 1 : 0,
            xdata: seriesItem.name
          })
        })
      })
      this.$nextTick(() => {
        const xAxis = this.$chart.getXAxis(xData)
        // 定义值只显示几条柱子
        const dataZoomLg = 24
        const option = this.$chart.columnChart(xData, seriesData, true, {
          show: dataList.length > dataZoomLg,
          dataZoomLg: dataZoomLg,
          bottom: 30,
          zoomLock: false,
          xAxisIndex: xAxis.length > 1 ? [0, 1] : [0]
        }, {
          top: 80,
          left: 20,
          right: 20,
          bottom: dataList.length > dataZoomLg ? 80 : 30
        }, {
          top: 5,
          right: 0,
          itemGap: 30,
          itemHeight: 10,
          itemWidth: 10
        }, xAxis)
        // 图形销毁重新绘制
        document.getElementById(id).removeAttribute('_echarts_instance_')
        // 重新绘制,重新加载数据
        const myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        // 根据屏幕的大小来缩放
        window.onresize = () => {
          myChart.resize()
        }
      })
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/less/color.less';
.compet-logo-box{
  margin-left: calc(~'50% - 45px');
  text-align: left;
  & .compet-figure-logo-box{
    width: 30px;
    height: 30px;
    margin-right: 8px;
  }
}
.form-item-searchStr-box{
  & .el-cascader{
    width: 350px;
  }
  & .el-radio__input.is-checked .el-radio__inner{
    background: #fff;
    border: 2px solid @color-orange;
  }
  & .el-radio__input.is-checked .el-radio__inner::after{
    background-color: @color-orange;
  }
}
.form-item-quota-box .el-radio__input.is-checked+.el-radio__label,
.form-item-searchStr-box .el-radio__input.is-checked+.el-radio__label{
  color: #666;
}
</style>
<style lang="less" scoped>
@import '~@/assets/less/color.less';
.wrap-contribute-compare{
  & .list-filter-wrap-box{
    position: fixed;
    top: 14px;
    width: calc(~'100vw - 215px');
    background-color: #F5F5F5;
    padding-bottom: 15px;
    z-index: 9;
  }
  & .wrap-main-content{
    margin-top: 114px;
  }
  & .chart-box{
    height: 480px;
  }
  & .item-bar-chart-box{
    width: 50%;
  }
  & .volumn-filter-box{
    top: -53px;
    left: 15%;
    z-index: 2;
    & .volumn-list-filter{
      padding-top: 0px;
    }
  }
  & .second-title{
    position: relative;
    padding: 0 15px;
    &::before{
      content: '';
      position: absolute;
      top: 3px;
      left: 5px;
      width: 2px;
      height: 15px;
      background-color: @color-blue;
    }
  }
}
/deep/.login-out-box{
  top: 25px;
  right: 30px;
}
/deep/.compet-table .el-table{
  min-height: 607px!important;
}
</style>
